module.exports = {"140215100":"西坪镇","140215101":"倍加造镇","140215102":"周士庄镇","140215201":"吉家庄乡","140215202":"峰峪乡","140215204":"杜庄乡","140215205":"党留庄乡","140215207":"瓜园乡","140215209":"聚乐乡","140215211":"许堡乡","140215401":"湖东","140215402":"东街","140215403":"西街"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140215.json
// module id = 276
// module chunks = 0